import React from 'react'
import attached from '../../../../Global/assets/EARLOBES/Attached.jpg'
import free from '../../../../Global/assets/EARLOBES/Free.jpg'
const Earlobes = () => {
    return (
        <>
            <div id="ExperimentsB" style={{ height: '110vh' }}>
                <div style={{
                    width: '80%', 
                    height: '50%', 
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <div style={{
                        width: '50%',
                        color:'#ffffff',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <img src={attached} style={{
                            width:'45%',
                            height:'80%'
                        }} alt="" />
                        <h5 className="h5">Joined Earlobe</h5>
                    </div>
                    <div style={{
                        width: '50%',
                        color:'#ffffff',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <img src={free} style={{
                            width:'45%',
                            height:'80%'
                        }} alt="" />
                        <h5 className="h5">Free Earlobe</h5>
                    </div>
                </div>
                <div style={{ width: '80%', height: '30vh', color: '#fff' }}>
                    <h1>Free and Joined Earlobes</h1><br />
                    <h6>Observations : </h6><br />
                    <h6>It is seen that the Free Earlobe is a dominant trait in the society.</h6><br />
                    <h6>From that which we can conclude that it has originated befmore the Joined Earlobe.</h6>
                </div>
            </div>
        </>
    )
}

export { Earlobes }